<!-- 我的网销商品 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" class="search-btn btn-primary" @click="addTab()" v-if="permission.shared">添加网销商品</el-button>
                <el-button size="small" class="search-btn" type="primary" v-if="permission.editProduct" @click="batchOpen">
                    批量上架 {{ multipleSelection.length > 0 ? '(' + multipleSelection.length + ') 项' : '' }}</el-button
                >
                <el-button size="small" class="search-btn" type="danger" v-if="permission.editProduct" @click="batchStop">
                    批量下架 {{ multipleSelection.length > 0 ? '(' + multipleSelection.length + ') 项' : '' }}</el-button
                >
                <!-- <el-button size="small" class="search-btn btn-primary" @click="trans()" v-if="permission.trans">转为销售单</el-button> -->
            </div>
            <div class="search-ctn-right">
                <div class="search-name">汽配编码、互换码</div>
                <el-input
                    class="search-item"
                    style="width: 135px"
                    size="small"
                    v-model.trim="searchData.code"
                    v-filter-special-char="searchData.code"
                    placeholder="汽配编码、互换码"
                ></el-input>
                <div class="search-name">汽配名称</div>
                <el-input
                    class="search-item"
                    style="width: 120px"
                    size="small"
                    v-model.trim="searchData.goodsName"
                    v-filter-special-char="searchData.goodsName"
                    placeholder="请输入汽配名称"
                ></el-input>
                <div class="search-name">适用车型</div>
                <el-input
                    class="search-item"
                    style="width: 120px"
                    size="small"
                    v-model.trim="searchData.autoSerise"
                    v-filter-special-char="searchData.autoSerise"
                    placeholder="适用车型"
                ></el-input>
                <div class="search-name">品牌</div>
                <div class="search-item goods-categories" style="width: 100px">
                    <el-select v-model.trim="searchData.brandName" filterable clearable size="small" @visible-change="brandVisibleChange($event)">
                        <el-option label="全部" value></el-option>
                        <el-option v-for="optionItem in brandList" :key="optionItem.Text" :label="optionItem.Text" :value="optionItem.Text"></el-option>
                    </el-select>
                </div>
                <div class="search-name">汽配分类</div>
                <div class="search-item goods-categories" style="width: 100px">
                    <el-select size="small" v-model="searchData.cate" filterable clearable @visible-change="cateVisibleChange($event)">
                        <el-option label="全部" value></el-option>
                        <el-option v-for="optionItem in apCategoryList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                            <div class="option-content">
                                <div>{{ optionItem.Text }}</div>
                            </div>
                        </el-option>
                    </el-select>
                </div>
                <div class="search-name">状态</div>
                <div class="search-item" style="width: 100px">
                    <el-select v-model="searchData.state" size="small">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="已上架" value="1"></el-option>
                        <el-option label="已下架" value="0"></el-option>
                    </el-select>
                </div>
                <!-- <div class="search-item" style="width: auto; margin-left: 15px">
                    <el-button
                        size="small"
                        type="primary"
                        @click="$refs.carTypeSelector.show()"
                        title="点击选择"
                        style="background-color: #f5f7fa; color: #909399; border: 1px solid #dcdfe6; font-size: 14px; padding: 8px 15px"
                        >精准车型</el-button
                    >
                    <el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)" style="font-size: 14px; background-color: #fff">{{
                        tag
                    }}</el-tag>
                </div> -->
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                ref="shareTableData"
                :data="tableData"
                border
                style="width: 100%"
                @selection-change="handleSelectionChange"
                :row-key="getRowKeys"
                @cell-dblclick="handleDBClick"
            >
                <el-table-column type="selection" reserve-selection></el-table-column>
                <el-table-column width="200px" prop="APCode" label="汽配编码" show-overflow-tooltip></el-table-column>
                <el-table-column width="200px" prop="GoodCode" label="互换码" show-overflow-tooltip></el-table-column>
                <el-table-column prop="GoodsName" label="汽配名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="AutoSerise" label="适用车型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Unit" label="单位" show-overflow-tooltip></el-table-column>
                <el-table-column prop="CostPrice" label="成本价" show-overflow-tooltip></el-table-column>
                <el-table-column prop="WholesalePrice" label="批发价" show-overflow-tooltip></el-table-column>
                <el-table-column prop="RetailPrice" label="零售价" show-overflow-tooltip></el-table-column>
                <el-table-column prop="SharePrice" label="网销价" show-overflow-tooltip></el-table-column>
                <el-table-column width="80px" prop="Inventory" label="库存" show-overflow-tooltip></el-table-column>
                <el-table-column width="80px" prop="ShareInventory" label="网销库存" show-overflow-tooltip></el-table-column>
                <el-table-column width="80px" prop="RemainingShareInventory" label="剩余库存" show-overflow-tooltip></el-table-column>
                <el-table-column width="80px" prop="SellCount" label="销量" show-overflow-tooltip :render-header="renderHeader"></el-table-column>
                <el-table-column label="网销状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-popover placement="top-start" title="原因：" trigger="hover" :content="scope.row.RefusalReason" v-if="scope.row.ShareState == 2">
                            <!-- <img src="../../../assets/images/info.png" alt="" class="info-icon"> -->
                            <el-button icon="el-icon-info" slot="reference" size="small " style="padding: 0; border: 0; color: #f56c6c"></el-button>
                        </el-popover>
                        <span>
                            {{ shareStateFilter(scope.row.ShareState) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" :autoWidth="true">
                    <template slot-scope="scope">
                        <!-- <el-button
              type="text"
              size="medium"
              @click="getShareGoodsDetail(scope.row.GoodsId, 'lookover')"
              v-if="permission.checkProduct"
            >查看</el-button>-->
                        <div class="ops-ctn">
                            <el-button type="text" size="mini" @click="getShareGoodsDetail(scope.row.GoodsId, 'edit')" v-if="permission.editProduct">编辑</el-button>
                            <el-button
                                @click="setShareInventoryState(scope.row.GoodsId, 'stop')"
                                type="text"
                                size="mini"
                                style="color: orange"
                                v-if="scope.row.ShareState == 1 && permission.editProduct"
                                >下架</el-button
                            >
                            <el-button
                                @click="setShareInventoryState(scope.row.GoodsId, 'open')"
                                type="text"
                                size="mini"
                                v-if="scope.row.ShareState == 4 && permission.editProduct"
                                >上架</el-button
                            >
                            <el-button
                                @click="setShareInventoryState(scope.row.GoodsId, 'del')"
                                type="text"
                                size="mini"
                                style="color: red"
                                v-if="scope.row.ShareState != 1 && permission.editProduct"
                                >移除</el-button
                            >
                        </div>
                        <!-- 未取消的都可以取消 ,审核不通过的不可取消-->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                    v-if="tableDataLength != 0"
                ></el-pagination>
            </div>
            <template>
                <SIGoodsDetailPage
                    @closeDialogForm="closeDialogForm"
                    :propsGoodsId="IGoodsDetail.goodsId"
                    :action="IGoodsDetail.action"
                    :dialogFormVisible="IGoodsDetail.dialogFormVisible"
                ></SIGoodsDetailPage>
            </template>
            <autoSeries ref="carTypeSelector" @chooseResult="chooseResult" />
        </div>
    </div>
</template>
<script>
import autoSeries from '@/components/common/chooseAutoSeries.vue';
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import SIGoodsDetailPage from '@/views/business/shareInventory/editSIGoods';
import Vue from 'vue';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: { SIGoodsDetailPage, breadcrumb, elTableColumn, autoSeries },
    data() {
        return {
            searchData: {
                code: '',
                goodsName: '',
                autoSerise: '',
                brandName: '',
                cate: '',
                sId: '',
                state: '',
                page: 1,
                limit: 15
            },
            dynamicTags: [],
            brandList: [],
            apCategoryList: [],
            tableData: [],
            tableDataLength: 0,
            submitData: {},
            permission: [],
            IGoodsDetail: {
                goodsId: '',
                action: '',
                dialogFormVisible: false
            },
            multipleSelection: []
        };
    },
    mounted() {
        let history_searchParams = this.$util.getLocalStorage('buyReturnOut_searchParams');
        if (history_searchParams) {
            //判断查询参数是否有记录
            this.searchData = history_searchParams;
            this.$util.clearLocalStorage('buyReturnOut_searchParams'); //用完即删
        }
        //现货网销-网销订单 权限:check_Product edit_Product shared
        this.permission = this.$util.getPermission('MyShareGoods');
        let AutoSerieData = this.$util.getLocalStorage('AutoSerieData');
        if (AutoSerieData) {
            //清空查询条件,旧数据
            this.resetSearch();
            this.tableData = [];
            this.tableDataLength = 0;
            this.searchData.sId = AutoSerieData.AutoSerieId;
            this.dynamicTags = [`${AutoSerieData.Brand} | ${AutoSerieData.AutoSerieName} | ${AutoSerieData.Emission} | ${AutoSerieData.ProducedYear}`];
            this.$util.clearLocalStorage('AutoSerieData'); //用完即删
        }
        this.getShareInventoryList();
    },
    // beforeRouteEnter(to, from, next) {
    //   next((vm) => {
    //     //因为当钩子执行前，组件实例还没被创建
    //     // vm 就是当前组件的实例相当于上面的 this，所以在 next 方法里你就可以把 vm 当 this 来用了。
    //     //搜索车架号页面传过来的参数
    //     let AutoSerieData = vm.$util.getLocalStorage("AutoSerieData");
    //     if (AutoSerieData) {
    //       //清空查询条件,旧数据
    //       vm.resetSearch();
    //       vm.tableData = [];
    //       vm.tableDataLength = 0;
    //       vm.searchData.sId = AutoSerieData.AutoSerieId;
    //       vm.dynamicTags = [
    //         `${AutoSerieData.Brand} | ${AutoSerieData.AutoSerieName} | ${AutoSerieData.Emission} | ${AutoSerieData.ProducedYear}`,
    //       ];
    //       vm.$util.clearLocalStorage("AutoSerieData"); //用完即删
    //       this.getShareInventoryList();
    //     }
    //   });
    // },
    activated() {
        //搜索车架号页面传过来的参数
        let AutoSerieData = this.$util.getLocalStorage('AutoSerieData');
        if (AutoSerieData) {
            //清空查询条件,旧数据
            this.resetSearch();
            this.tableData = [];
            this.tableDataLength = 0;
            this.searchData.sId = AutoSerieData.AutoSerieId;
            this.dynamicTags = [`${AutoSerieData.Brand} | ${AutoSerieData.AutoSerieName} | ${AutoSerieData.Emission} | ${AutoSerieData.ProducedYear}`];
            this.$util.clearLocalStorage('AutoSerieData'); //用完即删
            this.getShareInventoryList();
        }
    },
    methods: {
        renderHeader(h, { column }) {
            const content = [
                h(
                    'div',
                    {
                        slot: 'content'
                    },
                    '此处的销量单指网销商品的销量，不包括其他途径出售商品的销量'
                )
            ];
            return h('span', [
                h(
                    'el-tooltip',
                    {
                        props: {
                            placement: 'bottom'
                        }
                    },
                    [
                        content,
                        h('i', {
                            class: 'el-icon-warning-outline',
                            style: 'color:orange;margin-right:5px;'
                        })
                    ]
                ),
                h('span', column.label)
            ]);
        },
        shareStateFilter(state) {
            switch (state) {
                case 0:
                    return '待审核';
                case 1:
                    return '已上架';
                case 2:
                    return '审核不通过';
                case 3:
                    return '已取消网销';
                case 4:
                    return '已下架';
            }
        },
        //获取网销库存列表
        getShareInventoryList() {
            this.$util
                .axiosGet({
                    url: '/api/ShareInventory/GetShareInventoryList',
                    data: this.searchData
                })
                .then(res => {
                    if (res.data) {
                        this.tableData = res.data;
                        this.tableDataLength = res.count;
                    } else {
                        this.tableData = [];
                        this.tableDataLength = 0;
                    }
                })
                .catch(err => {});
        },
        // 设置网销商品状态
        setShareInventoryState(_goodsIds, _state) {
            let that = this;
            let title = '';
            switch (_state) {
                case 'stop':
                    title = '确定下架网销';
                    break;
                case 'del':
                    title = '确定删除网销';
                    break;
                case 'open':
                    title = '确定上架网销';
                    break;
                default:
                    return;
            }
            that.$confirm(title, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let temp = [_goodsIds];
                    that.$util
                        .axiosPost({
                            url: '/api/ShareInventory/SetShareInventoryState',
                            data: {
                                goodsIds: temp,
                                state: _state
                            }
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg('更新成功');
                                that.getShareInventoryList();
                            }
                        })
                        .catch(err => {});
                })
                .catch(err => {});
        },
        //获取品牌分类
        getEnterprisePartBrandList() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                })
                .catch(() => {});
        },
        //获取汽配分类
        getEntpApCategoryList() {
            this.$util
                .getEntpApCategoryList()
                .then(data => {
                    if (!data) return;
                    this.apCategoryList = data;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getShareInventoryList();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getShareInventoryList();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getShareInventoryList();
        },
        resetSearch() {
            this.searchData = {
                code: '',
                goodsName: '',
                autoSerise: '',
                brandName: '',
                state: '',
                cate: '',
                sId: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.dynamicTags = [];
        },
        //添加网销商品 2020.4.14 已经修改了方式是跳转页面
        addTab() {
            let searchParams = this.searchData;
            Vue.set(searchParams, 'dataIndex', 'buyReturnOut');
            this.$util.setLocalStorage('buyReturnOut_searchParams', searchParams); //保存当前查询参数，返回页面时使用

            this.$router.push('/shareInventory/shareGoods');
        },
        trans() {
            let that = this;
            if (!that.multipleSelection) {
                that.$util.warningMsg('请选择商品');
                return;
            }
            let ids = [];
            that.multipleSelection.forEach(e => {
                ids.push(e.GoodsId);
            });
            this.$util.setLocalStorage('SI_GoodsData', ids);
            this.$router.push(`/salesManage/salesOrder/edit_v2?type=3`);
        },
        //获取网销商品详情
        getShareGoodsDetail(goodsId, action) {
            this.IGoodsDetail = {
                goodsId: goodsId,
                action: action,
                dialogFormVisible: true
            };
        },
        closeDialogForm(data) {
            let that = this;
            if (data && data.action == 'addsuccess') {
                this.IGoodsDetail.dialogFormVisible = false;
                that.getShareInventoryList();
            }
            this.IGoodsDetail.dialogFormVisible = false;
        },
        //表单双击事件
        handleDBClick(event) {
            if (event.GoodsId && this.permission.checkProduct) {
                this.getShareGoodsDetail(event.GoodsId, 'lookover');
            }
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brandList.length == 0) that.getEnterprisePartBrandList();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.apCategoryList.length == 0) that.getEntpApCategoryList();
            }
        },
        handleClose(tag) {
            this.searchData.sId = '';
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        },
        // 选择车型返回结果
        chooseResult(arr) {
            this.searchData.sId = arr.SId;
            this.dynamicTags = [`${arr.Cn} | ${arr.AutoSerieName} | ${arr.Emission} | ${arr.ProducedYear} | ${arr.SaleModel}`];
            // 关闭弹框
            setTimeout(() => {
                this.$refs.carTypeSelector.hide();
            }, 1000);
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        getRowKeys(row) {
            return row.GoodsId;
        },
        batchOpen() {
            let that = this;
            let arr = this.multipleSelection.filter(f => f.ShareState == 4);
            if (arr.length == 0) {
                that.$util.warningMsg('未检测到要上架的商品');
                return;
            }
            let idList = [];
            for (let i = 0; i < arr.length; i++) {
                idList.push(arr[i].GoodsId);
            }
            that.$confirm('确定将这些网销商品上架吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$util
                    .axiosPost({
                        url: '/api/ShareInventory/BatchOpenShare',
                        data: {
                            GoodsIds: idList
                        }
                    })
                    .then(res => {
                        if (res.errcode == 0) {
                            that.$util.successMsg('上架成功！');
                            that.$refs.shareTableData.clearSelection();
                            that.getShareInventoryList();
                        }
                    });
            });
        },
        batchStop() {
            let that = this;
            let arr = this.multipleSelection.filter(f => f.ShareState == 1);
            if (arr.length == 0) {
                that.$util.warningMsg('未检测到要下架的商品');
                return;
            }
            let idList = [];
            for (let i = 0; i < arr.length; i++) {
                idList.push(arr[i].GoodsId);
            }
            that.$confirm('确定将这些网销商品下架吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$util
                    .axiosPost({
                        url: '/api/ShareInventory/BatchStopShare',
                        data: {
                            GoodsIds: idList
                        }
                    })
                    .then(res => {
                        if (res.errcode == 0) {
                            that.$util.successMsg('下架成功！');
                            that.$refs.shareTableData.clearSelection();
                            that.getShareInventoryList();
                        }
                    });
            });
        }
    }
};
</script>
